import { render, staticRenderFns } from "./AdminAudits.vue?vue&type=template&id=33641918&scoped=true"
import script from "./AdminAudits.vue?vue&type=script&lang=js"
export * from "./AdminAudits.vue?vue&type=script&lang=js"
import style0 from "./AdminAudits.vue?vue&type=style&index=0&id=33641918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33641918",
  null
  
)

export default component.exports